module.exports = __webpack_public_path__ + "images/home-dingtalk-work/hero_bg-c1593005b6caa4265ea0c4d59e1f53b6.jpg";